import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { InsuranceCompany } from '../_types/insurance-company';
import { InsuranceCompaniesService } from '../_services/insurance-companies.service';

@Component({
    selector: 'app-insurance-companies-detail',
    templateUrl: './insurance-companies-detail.component.html',
    styleUrls: ['./insurance-companies-detail.component.scss'],
    standalone: false
})
export class InsuranceCompanyDetailComponent {
  public insuranceCompanyFormGroup!: RxFormGroup;

  public insuranceCompany: InsuranceCompany = new InsuranceCompany();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private insuranceCompaniesService: InsuranceCompaniesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {

    this.insuranceCompanyFormGroup = this.formBuilder.formGroup<InsuranceCompany>(this.insuranceCompany) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de la compañía de seguros");
    this.topbarService.addBreadcrumb("Compañías de seguros", "/insuranceCompanies");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadInsuranceCompany(id);
    }
    this.allowWrite = this.loginService.hasPermission("INSURANCE_COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("INSURANCE_COMPANIES.DELETE");


  }

  async loadInsuranceCompany(id: string) {
    this.insuranceCompany = await firstValueFrom(this.insuranceCompaniesService.get(id));
    this.insuranceCompanyFormGroup.patchValue(this.insuranceCompany);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.insuranceCompanyFormGroup);
    if (valid) {
      this.insuranceCompany = Object.assign(this.insuranceCompany, this.insuranceCompanyFormGroup.value);

      let insuranceCompany = await firstValueFrom(this.insuranceCompaniesService.save(this.insuranceCompany));

      this.messageService.add({ closable: true, severity: 'success', summary: "Compañía de seguros guardada correctamente." });

      this.router.navigate(['insuranceCompanies']);
            

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la compañía de seguros "+this.insuranceCompany.name+"?",
      header: "Eliminar compañía de seguros",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.insuranceCompaniesService.delete(this.insuranceCompany.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Compañía de seguros eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['vehiclesTypes']);
  }

}
